import { JSONPath } from 'jsonpath-plus';
/**
 * Checks that the current-moment has no moments after it with a valid-from date.
 */
export function validFromNotAfterCurrentMoment(input, _, context) {
    if (!input) {
        return [];
    }
    const moments = JSONPath({ path: '$.moments[*]', json: context.document.data, resultType: 'value' });
    if (!moments || moments.length === 0) {
        // other rule will report no moments defined
        return [];
    }
    const currentMomentId = input;
    let checkingValidFroms = false;
    const results = [];
    for (const moment of moments) {
        const momentId = JSONPath({ path: '$.unique-id', json: moment, wrap: false });
        if (momentId && momentId === currentMomentId) {
            checkingValidFroms = true;
            continue;
        }
        if (checkingValidFroms) {
            const validFrom = JSONPath({ path: '$.valid-from', json: moment, wrap: false });
            if (validFrom) {
                results.push({
                    message: `Moment with unique-id "${momentId}" is after current-moment "${currentMomentId}" but has a valid-from.`
                });
            }
        }
    }
    return results;
}
//# sourceMappingURL=valid-from-not-after-current-moment.js.map